/**
 * Add components by event and in your desired order
 * @type {[*]}
 */
let components = [
    [
        "ready",
        [
            require("./../components/animation"),
            // require("./../lib/equal-heights"),
            require("./../components/cookie-notice"),
            require("./../components/general"),
            require("./../components/form"),
            require("./../components/scroller"),
            require("./../components/trigger"),
            require("./../components/share-copy-link"),
            require("./../components/filter"),
            require("./../components/filter-toggle"),
            // require('./../components/filter-lazy-load'),
            require("./../components/slider"),
            // require('./../components/waypoints'),
            // require("./../components/popup"),
            require("./../components/header"),
            require("./../components/floating-contact-button"),
            require("./../components/video-player"),
            require("./../components/lightbox"),
            require("./../components/expertise-nav"),
        ],
    ],
];

module.exports = components;
